import type { IconProps } from '../types/IconProps.ts';
export const ListOrdered: IconProps = {
    name: 'ListOrdered',
    children: [
        `<path d="M13 5h8M13 12h8M13 19h8M4.5 4h1c.28 0 .5.22.5.5V10m0 0H4.5M6 10h1.5M4.5 15.29l.63-.54a1.63 1.63 0 1 1 2.12 2.47L6 18.29l-.97.83a.5.5 0 0 0 .32.88H9" />`,
    ]
};